const filterConditionStyles: any = {
  control: (styles: StyleSheet) => ({
    ...styles,
    borderRadius: '0.375rem',
    border: '1px solid #D0D5DD',
    borderColor: 'rgb(208 213 221 / var(--tw-border-opacity))',
    background: '#ffffff',
    boxShadow: 'none',
    fontSize: '',
    fontWeight: 400,
    minHeight: '34px',
    ':focus': {
      borderColor: '#085ccc',
    },
    ':hover': {
      borderColor: '#e5e7eb',
    },
  }),
  valueContainer: (styles: StyleSheet) => ({
    ...styles,
    padding: '2px 6px',
    gap: '2px',
  }),
  indicatorSeparator: () => ({
    width: 0,
  }),
  dropdownIndicator: (styles: StyleSheet) => ({
    ...styles,
    padding: '0 6px',
    color: '#9ca3af',
  }),
  multiValue: (styles: StyleSheet) => ({
    ...styles,
    backgroundColor: '#eff6ff',
    border: '1px solid #bfdbfe',
    borderRadius: '4px',
    color: '#1e40af',
    fontSize: '12px',
    maxWidth: 150,
    margin: '1px',
  }),
  multiValueLabel: (styles: StyleSheet) => ({
    ...styles,
    color: '#1e40af',
    fontWeight: 500,
    fontSize: '12px',
    padding: '1px 4px',
    paddingLeft: '6px',
  }),
  multiValueRemove: (styles: StyleSheet) => ({
    ...styles,
    color: '#3b82f6',
    paddingLeft: '2px',
    paddingRight: '4px',
    ':hover': {
      backgroundColor: '#dbeafe',
      color: '#1e40af',
      borderRadius: '0 4px 4px 0',
    },
  }),
  option: (
    styles: StyleSheet,
    { isSelected, isFocused }: { isSelected: boolean; isFocused: boolean },
  ) => ({
    ...styles,
    background: isSelected ? '#1d4ed8' : isFocused ? '#eff6ff' : '#ffffff',
    margin: '2px 0',
    fontSize: '13px',
    color: isSelected ? '#fff' : '#1f2938',
    ':hover': {
      background: isSelected ? '#1d4ed8' : '#eff6ff',
    },
  }),
  placeholder: (styles: StyleSheet) => ({
    ...styles,
    whiteSpace: 'nowrap',
    color: '#9ca3af',
    fontWeight: 'normal',
    fontSize: '13px',
  }),
  menu: (styles: StyleSheet) => ({
    ...styles,
    fontSize: '13px',
    zIndex: 9999,
  }),
}

export default filterConditionStyles
